<template>
    <v-autocomplete
            :label="(label)? label : 'Búsqueda de item'"
            :items="items"
            :value="value"
            item-text="descripcion"
            item-value="id"
            clearable
            hide-no-data
            :search-input.sync="search"
            @input="actualizaValor($event)"
            :loading="loading"
            return-object
            :error-messages="errores.collect('item')"
            v-validate="validate"
            data-vv-name="item"
            @blur="$emit('blur')"
            @change="change($event)"
            :filter="customFilter"
            append-outer-icon="fa-copy"
            @click:append-outer="codigoCopia()"
    >
        <template slot="item" slot-scope="data">
            <v-list-tile-content>
                <v-list-tile-title>{{ data.item.descripcion}}</v-list-tile-title>
                <v-list-tile-sub-title>
                    {{ (data.item.micro_id_1)? ' FRIO: ' + data.item.micro_id_1 : ''}}
                    {{ (data.item.micro_id_2)? ' | BERVILL: ' + data.item.micro_id_2 : '' }}
                    {{ (data.item.micro_id_3)? ' | ACERO: ' + data.item.micro_id_3 : '' }}
                </v-list-tile-sub-title>
            </v-list-tile-content>
        </template>
    </v-autocomplete>
</template>
<script>
    import mixinItem from '../mixins/items';
    import {mapActions} from 'vuex';

    export default {
        inject: ['$validator'],
        name: 'item-select',
        props: ['label', 'value', 'tipo', 'preset', 'validate'],
        mixins: [mixinItem],
        data() {
            return {
                search: '',
                loading: false,
                items: []
            }
        },
        watch: {
            search(val) {
                if (!val) {
                    return false;
                }
                let valor = (this.value && typeof this.value === 'object' && this.value.descripcion) ? this.value.descripcion : '';
                val && val !== valor && this.query(val)
            },
            preset(val) {
                this.items = (val && Object.keys(val).length !== 0) ? [val] : [];
            }
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            query(val) {
                this.loading = true;
                this.itemSearch(this.tipo, val, r => {
                    this.items = r;
                    this.loading = false;
                }, err => {
                    console.log(err);
                    this.loading = false;
                })
            },
            customFilter(item, queryText, itemText) {
                let micro_id_1 = (item.micro_id_1) ? item.micro_id_1.toLowerCase().includes(queryText.toLowerCase()) : false;
                let micro_id_2 = (item.micro_id_2) ? item.micro_id_2.toLowerCase().includes(queryText.toLowerCase()) : false;
                let micro_id_3 = (item.micro_id_3) ? item.micro_id_3.toLowerCase().includes(queryText.toLowerCase()) : false;
                let descripcion = (item.descripcion) ? item.descripcion.toLowerCase().includes(queryText.toLowerCase()) : false;
                return (micro_id_1 || micro_id_2 || micro_id_3 || descripcion);
            },
            actualizaValor(valor) {
                this.$emit('update:id', (valor) ? valor.id : '');
                this.$emit('update:ancho', (valor) ? valor.ancho : '');
                this.$emit('input', valor);
            },
            change(e) {
                this.$emit('change', e);
                this.$emit('update:id', (e) ? e.id : '');
            },
            codigoCopia() {
                if (!this.value) {
                    return false;
                }
                let txt = 'ID: ' + this.value.id + 'FRIO:' + this.value.micro_id_1 + ' | BERVILL:' + this.value.micro_id_2 + ' | ACERO:' + this.value.micro_id_3
                this.$copyText(txt)
                    .then(r => {
                        this.msjShow({tipo: 1, txt: 'Código copiado al portapapeles',});
                        console.log(r)
                    }, err => {
                        console.log(err)
                    })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/ItemSelect.vue